<button mat-stroked-button color="primary" (click)="mlResponse('good')" class="good-button" id="knowledge_good">
    {{ goodText }}
</button>
<!-- <button mat-stroked-button color="primary" (click)="mlResponse('content-feedback')" id="knowledge_feedback">
    {{ feedbackText }}
</button> -->
<button mat-stroked-button color="primary" (click)="mlResponse('knowledge-update')" id="knowledge_update">
    Knowledge Update
</button>
